import { initializeGainsight } from "./utils/init-gainsight";
import { GainsightProvider } from "./state/GainsightProvider";

export { useGainsightCustomEvent } from "./hooks/useGainsightCustomEvent";

export const serviceGainsight = ({ getConfig }) => {
  const gainsightEnabled = getConfig("one.gainsight.enabled", false);

  if (!gainsightEnabled) return [];

  initializeGainsight();

  return [
    {
      target: "$REACT_ROOT_WRAPPER",
      handler: { component: GainsightProvider }
    }
  ];
};
